import React from 'react';
import { useSearchParams } from 'react-router-dom';
import Welcome from './Welcome';
import PurchaseCrypto from './PurchaseCrypto';
// @mcc-dev-preview:import
import { parseDevState } from '../dev/devPreview';

// @mcc-dev-preview:start welcome-dev-state
const WELCOME_DEV_STATES = ['landing', 'purchase-loading', 'purchase-ready', 'no-coin'] as const;
// @mcc-dev-preview:end welcome-dev-state

const WelcomeRoute: React.FC = () => {
  const [searchParams] = useSearchParams();
  const cardId = searchParams.get('cardId')?.trim();
  // @mcc-dev-preview:start welcome-dev-state
  const devState = parseDevState(searchParams, WELCOME_DEV_STATES);

  if (devState === 'landing') {
    return <Welcome />;
  }

  if (
    devState === 'purchase-loading' ||
    devState === 'purchase-ready' ||
    devState === 'no-coin'
  ) {
    return <PurchaseCrypto />;
  }
  // @mcc-dev-preview:end welcome-dev-state

  if (cardId) {
    return <PurchaseCrypto />;
  }

  return <Welcome />;
};

export default WelcomeRoute;
